import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {setGalleryActiveImageIndex, toggleGalleryVisible} from "../../../actions/selectionFunctions";
import {featureThumbnailUrl} from "../../../misc/helpers";
import {THUMBNAIL_SIZES} from "../../../misc/utils";
import Analytics from '../../../analytics';

const FeatureInfoImagesMobile = (props) => {

  const {selectionFeatureInfo} = props;
  const galleryExist = Array.isArray(selectionFeatureInfo.dbFeature.galleryImages)
    && selectionFeatureInfo.dbFeature.galleryImages.length;

  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    let featureGalleryImages = galleryExist ? selectionFeatureInfo.dbFeature.galleryImages : [];
    setGalleryImages([{
      url: featureThumbnailUrl(selectionFeatureInfo),
      preview: featureThumbnailUrl(selectionFeatureInfo, THUMBNAIL_SIZES.small)
    },  // main image thumbnail
      ...featureGalleryImages
    ])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!galleryExist) {
    return null
  }

  const thumbnailClick = (index) => {
    Analytics.sendClickEvent('gallery-image-thumbnail-clicked');
    props.toggleGalleryVisible(true);
    props.setGalleryActiveImageIndex(index);
  };

  return (
    <div className="product-gallery">
        <h5 className="product-gallery__title">
          <FormattedMessage id="quotingTool.featureInfo.galleryTitle"/>
        </h5>
      {galleryImages.length > 1 ? (
        <ul className={"product-gallery__images"
        + (galleryImages.length > 3 ? " product-image__gallery--more-that-three" : "")
        + (galleryImages.length > 6 ? " product-image__gallery--more-that-six" : "")}>
          {galleryImages.map((gImg, index) => {
            return <li className="product-image__gallery-image"
                       key={index}
                       style={{backgroundImage: "url('" + (gImg.preview || gImg.url) + "')"}}
                       onClick={() => thumbnailClick(index)} />
          })}
        </ul>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    windowWidth: store.serverState.windowWidth,
  };
};

export default connect(mapStateToProps, {
  toggleGalleryVisible,
  setGalleryActiveImageIndex
})(FeatureInfoImagesMobile);
